import { ILeaderboard } from '@kattana-io/common';
import Leaderboard from './Leaderboard';
import Profile from './Profile';
import Competitions from './Competitions';
import AdditionalPoints from './AdditionalPoints';

interface ICompetitionBodyProps {
  leaderboard: ILeaderboard[];
}

const CompetitionBody = ({ leaderboard }: ICompetitionBodyProps) => {
  return (
    <div className='competitions'>
      <div className='competitions__top_block'>
        <Profile />
        <Leaderboard data={leaderboard} />
      </div>
      <div className='competitions__bottom_block'>
        <Competitions />
        <AdditionalPoints />
      </div>
    </div>
  );
};

export default CompetitionBody;
